// removed by extract-text-webpack-plugin
module.exports = {"root":"_3WIyJ","trigger":"_3Kgdw","dropdown":"_30uM_","dropdownMenuItem":"_3j4yj","title":"_3fGsR","dropdownMenu":"_UwsJI","dropdownMenuGroup":"_3wYBf","link":"_266wt"};


//////////////////
// WEBPACK FOOTER
// ./app/components/PageListHeader/components/PageList/PageList.scss
// module id = 874
// module chunks = 9